import React, { Component } from 'react';

import { SCREEN_ID_UTILITY_SETUP_NEW_CUSTOMER_DEALS } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withLocationQuery from 'client/helpers/withLocationQuery';

import branch from 'client/core/branch';
import UtilityPartnerActions from 'client/actions/UtilityPartner';
import UtilityActivationActions from 'client/actions/UtilityActivation';

import SrUtilitySetupPage from 'client/components/SrUtilitySetup/SrUtilitySetupPage';
import SrUtilitySetupProviderNewCustomerDeals from 'client/components/SrUtilitySetup/SrUtilitySetupProviderNewCustomerDeals';

@withTransitionHook
@withLocationQuery
@withScreenId(SCREEN_ID_UTILITY_SETUP_NEW_CUSTOMER_DEALS)
@withScrollToTop
@branch(({ match }) => ({
  utilityActivation: ['utilityActivations', 'byShortId', match.params.utilityActivationShortId],
  utilityPartner: ['utilityPartners', 'bySlug', match.params.partnerSlug],
}))
@branch(({ utilityActivation }) => {
  if (utilityActivation) {
    return {
      internetProviders: [
        'utilityProviders',
        'internetPlansByPartnerAddressId',
        utilityActivation.utilityPartnerAddressId,
      ],
    };
  }
  return {};
})
class UtilitySetupProviderPlanCustomerDealsPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Setup | Plan',
  });

  static fetchData(match, inject) {
    return Promise.all([
      UtilityPartnerActions.getBySlug(inject, {
        slug: match.params.partnerSlug,
      }),
      UtilityActivationActions.getByShortId(inject, {
        utilityActivationShortId: match.params.utilityActivationShortId,
      }),
    ]).then(([, utilityActivation]) => {
      if (utilityActivation) {
        return UtilityActivationActions.getInternetPlans(inject, {
          utilityPartnerAddressId: utilityActivation.utilityPartnerAddressId,
        });
      }

      return Promise.resolve();
    });
  }

  render() {
    const { utilityPartner, utilityActivation, internetProviders, match, history, locationQuery } = this.props;

    const utilityTypeLabel = match.params.utilityTypeLabel;
    const utilityProviderId = match.params.utilityProviderId
      ? parseInt(match.params.utilityProviderId, 10)
      : null;

    if (!utilityPartner || !utilityActivation) {
      return null;
    }

    const utilityActivationItem = utilityActivation.items.find(
      (item) => item.type.label.toLowerCase() === utilityTypeLabel,
    );

    return (
      <SrUtilitySetupPage
        addressDisplay={utilityActivation.address?.display}
        utilityPartner={utilityPartner}
        utilityActivationId={utilityActivation.id}
        logoUrl={utilityPartner.logoUrl}
        backButtonText="Back"
        backButtonUrl={`/utility-setup/${utilityPartner.slug}/${utilityActivation.shortId}/internet/plan`}
      >
        <SrUtilitySetupProviderNewCustomerDeals
          utilityProviderId={utilityProviderId}
          utilityPartner={utilityPartner}
          utilityActivation={utilityActivation}
          utilityActivationItem={utilityActivationItem}
          utilityProviders={internetProviders || utilityActivationItem.availableProviders}
          history={history}
          locationQuery={locationQuery}
        />
      </SrUtilitySetupPage>
    );
  }
}

UtilitySetupProviderPlanCustomerDealsPage.displayName = 'UtilitySetupProviderPlanPage';

export default UtilitySetupProviderPlanCustomerDealsPage;
